import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const prep = (md = "") => md.replace(/\[Complément externe\]/g, "**[Complément externe]**");

const Strong = ({ children }) => {
  const txt = String(Array.isArray(children) ? children.join("") : children);
  if (/^passage à vérifier/i.test(txt))
    return <span data-testid="uncertain-passage-badge" className="rounded-md bg-amber-400/20 px-1.5 py-0.5 text-[0.8em] font-bold text-amber-700 dark:text-amber-300">{children}</span>;
  if (txt === "[Complément externe]")
    return <span className="rounded-md bg-sky-500/15 px-1.5 py-0.5 text-[0.8em] font-bold text-sky-700 dark:text-sky-300">Complément externe</span>;
  return <strong>{children}</strong>;
};

export const Markdown = ({ children, className = "" }) => (
  <div className={`prose-notes ${className}`}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ strong: Strong }}>{prep(children)}</ReactMarkdown>
  </div>
);

export const HighlightedTranscript = ({ text }) => (
  <p className="whitespace-pre-wrap text-sm leading-relaxed">
    {text.split(/(\[Passage à vérifier : [^\]]*\])/g).map((part, i) =>
      part.startsWith("[Passage à vérifier") ? <mark key={i} className="rounded bg-amber-400/25 px-1 text-amber-800 dark:text-amber-200">{part}</mark> : part
    )}
  </p>
);
